export { default } from './UniversalChip/UniversalChip';

export { default as AlertParameterChip } from './Type/AlertParameterChip/AlertParameterChip';
export { default as ReferenceRangeChip } from './Type/ReferenceRangeChip/ReferenceRangeChip';
export { default as UserStatusChip } from './Type/UserStatusChip/UserStatusChip';
